export default __webpack_public_path__ + "static/media/close_gray.75deb0f4.svg";